<template>
    <div>
        <load mode="table" v-if="loading" />
        <form v-else @submit.prevent="cadastarPessoaReferencia" ref="addItem">
            <label class="d-block font-weight-bold mb-3">
                Registrar outras pessoas da família em situação de acolhimento:
            </label>
            <div class="row">
                <form-input 
                    v-model="nome" 
                    label="Nome da Pessoa" 
                    :required="true" 
                />
                <form-input
                    v-model="parentesco"
                    label="Parentesco/Posição Familiar"
                    grid="6"
                    :required="true"
                />
                <form-input 
                    label="Data de nascimento" 
                    v-model="data_nascimento" 
                    type="date"
                    grid="6"
                />
                <form-select
                    v-model="sexo"
                    :itens="$root.arrays.sexo"
                    label="Sexo"
                    grid="6"
                />
                <form-input
                    v-model="telefone"
                    label="Telefone"
                    v-mask="'(##) # ####-####'"
                    placeholder="(00) 0 0000-0000"
                    grid="6"
                />
                <form-input 
                    label="Local de Acolhimento" 
                    v-model="endereco" 
                    type="text"
                />
            </div>
            <div class="row col-12 pb-3 px-0 m-0 d-flex justify-content-end">
                <button class="btn btn-primary m-0" data-style="zoom-in" type="submit">
                    Cadastrar
                </button>
            </div>
        </form>
        <div class="row">
            <div class="col-12" v-if="pessoaReferencia.filter(p => p.tipo_cadastro === 'Familiar').length > 0">
                <label class="d-block font-weight-bold mb-3">
                    Outras pessoas da família em situação de acolhimento:
                </label>
                <table class="table table-sm border table-bordered mb-3" v-for="(pessoa, index) in pessoaReferencia.filter(p => p.tipo_cadastro === 'Familiar')">
                    <tbody>
                        <tr>
                            <td class="py-0" colspan="2">
                                Nome Completo: <b>{{ pessoa.nome }}</b>
                                <a
                                    title="Excluir"
                                    @click="excluirPessoa(pessoa.id, index)"
                                    class="float-right px-2 mb-0 text-danger "
                                >
                                    <i class="mdi mdi-close"></i>
                                </a>
                            </td>
                        </tr>
                        <tr>
                            <td class="py-0">
                                Parentesco/Posição Familiar:
                                <b>{{ pessoa.parentesco }}</b>
                            </td>
                            <td class="py-0">
                                Data de Nascimento:
                                <b>{{ formatarData(pessoa.data_nascimento) }}</b>
                            </td>
                        </tr>
                        <tr>
                            <td class="py-0">
                                Sexo:
                                <b>{{ formatarSexo(pessoa.sexo) }}</b>
                            </td>
                            <td class="py-0">
                                Telefone:
                                <b>{{ pessoa.telefone }}</b>
                            </td>
                        </tr>
                        <tr>
                            <td class="py-0" colspan="2">
                                Local de Acolhimento:
                                <b>{{ pessoa.endereco }}</b>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="col-12" v-else>
                <h4 class="text-secondary">
                    <i class="mdi mdi-24px mdi-alert-decagram-outline"></i>
                    Nada salvo aqui.
                </h4>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ["item"],
    data() {
        return {
            nome: "",
            parentesco: "",
            telefone: "",
            email: "",
            endereco: "",
            data_nascimento: "",
            sexo: "",
            documento_identidade: "",
            cpf: "",
            nome_guardiao: "",
            tipo_guarda: "",
            numero_processo_guarda: "",
            tipo_cadastro: "",
            loading: false,
            pessoaReferencia: {}
        };
    },
    watch: {
        item() {
            if (this.item.pessoaReferencia != null) {
                this.pessoaReferencia = this.item.pessoaReferencia;
            }
        }
    },
    mounted() {
        if (this.item.pessoaReferencia != null) {
            this.pessoaReferencia = this.item.pessoaReferencia;
        }
    },
    methods: {
        formatarData(data) {
            if (!data) return '';
            const d = new Date(data);
            const dia = ('0' + d.getDate()).slice(-2);
            const mes = ('0' + (d.getMonth() + 1)).slice(-2);
            const ano = d.getFullYear();
            return `${dia}/${mes}/${ano}`;
        },
        formatarSexo(sexo) {
            if (sexo === '1' || sexo === 1) return 'Masculino';
            if (sexo === '2' || sexo === 2) return 'Feminino';
            if (sexo === '3' || sexo === 3) return 'Intersexo';
            return 'Não informado';
        },
        calcularIdade(dataNascimento) {
            if (!dataNascimento) return null;
            const hoje = new Date();
            const nascimento = new Date(dataNascimento);
            let idade = hoje.getFullYear() - nascimento.getFullYear();
            const mes = hoje.getMonth() - nascimento.getMonth();
            if (mes < 0 || (mes === 0 && hoje.getDate() < nascimento.getDate())) {
                idade--;
            }
            return idade;
        },
        submit() {
            this.item.pessoaReferencia = this.pessoaReferencia;
            this.$emit("submit");
        },
        cadastarPessoaReferencia() {
            this.loading = true;
            let ladda = Ladda.create(document.querySelector(".btn-submit"));
            ladda.start();

            const idadeCalculada = this.calcularIdade(this.data_nascimento);

            axios
                .post(
                    `api/dashboard/acolhimento/idoso/storepessoa`,
                    {
                        nome: this.nome,
                        parentesco: this.parentesco || "-",
                        idade: idadeCalculada,
                        telefone: this.telefone || "-",
                        email: this.email || "-",
                        endereco: this.endereco || "-",
                        acolhimento_id: this.item.id,
                        data_nascimento: this.data_nascimento,
                        sexo: this.sexo,
                        documento_identidade: this.documento_identidade,
                        cpf: this.cpf,
                        nome_guardiao: this.nome_guardiao,
                        tipo_guarda: this.tipo_guarda,
                        numero_processo_guarda: this.numero_processo_guarda,
                        tipo_cadastro: "Familiar"
                    },
                    {
                        header: { "Content-Type": "multipart/form-data" },
                        onUploadProgress: event => {
                            let progress = Math.round(
                                (event.loaded * 100) / event.total
                            );
                            this.progressCompleted = progress;
                        }
                    }
                )
                .then(response => {
                    ladda.stop();

                    this.$snack.success({
                        button: false,
                        text: response.data.data.message
                    });
                    this.$emit("reload");
                })
                .finally(() => {
                    this.limpar();
                });
        },
        excluirPessoa(id) {
            swal.fire({
                text: "Aguarde a ação ser finalizada.",
                icon: "warning",
                showConfirmButton: false,
                timer: 1500
            });
            axios
                .get(`api/dashboard/acolhimento/idoso/pessoa/excluir/${id}`)
                .then(response => {
                    this.$snack.success({
                        button: false,
                        text: response.data.data.message
                    });
                    this.$emit("reload");
                });
        },
        verificarValueArray(value, array, valueIsArray = false) {
            if (valueIsArray && value) {
                var a = "";
                for (var i = 0; i < value.length; i++) {
                    const result = array.filter(item => item.id == value[i]);
                    a += result[0].value + (i < value.length - 1 ? "," : "");
                }

                return a;
            } else {
                const result = array.filter(item => item.id == value);
                return result[0] ? result[0].value : "";
            }
        },
        limpar() {
            this.nome = "";
            this.parentesco = "";
            this.idade = "";
            this.telefone = "";
            this.email = "";
            this.endereco = "";
            this.data_nascimento = "";
            this.sexo = "";
            this.documento_identidade = "";
            this.cpf = "";
            this.nome_guardiao = "";
            this.tipo_guarda = "";
            this.numero_processo_guarda = "";
            this.tipo_cadastro = "";
            this.loading = false;
        }
    }
};
</script>
